export default __webpack_public_path__ + "static/adac-launch_1_1_de-c5be623eadb2f21dc22f82162a17725d.png";